import {ChangelogProps} from './types';

const EChangelogAction = {
  Features: 'Features',
  BugFixes: 'Bug Fixes',
  BreakingChanges: '⚠ BREAKING CHANGES',
} as const;

export const conventionalChangelogParser = (content: string) => {
  const splittedLines = content.split(/\r?\n/);

  return splittedLines
    .reduce((resultArray: ChangelogProps[], item: string) => {
      if (item.trim() === '') {
        return resultArray;
      }

      if (item.trimStart().startsWith('## ')) {
        resultArray.push({
          versionNumber: getVersionNumber(item),
          actions: [],
          versionContent: '',
        });
        return resultArray;
      }

      const currentVersion = resultArray[resultArray.length - 1];
      if (!currentVersion) {
        return resultArray;
      }
      if (item.trimStart().startsWith('### ')) {
        const action = {
          name: item.trimStart().substring(4),
          content: '',
          counter: 0,
          icon: () => '',
        };
        currentVersion.actions.push(action);

        if (item.includes(`### ${EChangelogAction.Features}`)) {
          action.name = EChangelogAction.Features;
          action.icon = () => '✨';
        }

        if (item.includes(`### ${EChangelogAction.BugFixes}`)) {
          action.name = EChangelogAction.BugFixes;
          action.icon = () => '🐞';
        }

        if (item.includes(`### ${EChangelogAction.BreakingChanges}`)) {
          action.name = EChangelogAction.BreakingChanges;
          action.icon = () => '⚠️';
        }

        return resultArray;
      }

      let currentAction =
        currentVersion.actions[currentVersion.actions.length - 1];
      if (item.trimStart().startsWith('- ') || item.trimStart().startsWith('* ')) {
        if (!currentAction) {
          currentAction = {
            name: '',
            icon: () => ' ',
            counter: 0,
            content: '',
          };
          currentVersion.actions.push(currentAction);
        }
        currentAction.counter += 1;
        currentAction.content += `${currentAction.content ? '\n' : ''}${item.trim()}`;

        return resultArray;
      }

      currentAction.content += ` ${item.trim()}`;
      currentAction.content = currentAction.content.trim();

      return resultArray;
    }, [])
    .map(mergeVersionContent);
};

function getVersionNumber(item: string) {
  const version = item.match(/## \[?(\d+\.\d+\.\d+)\]?/)?.[1] ?? '';
  const date = item.match(/(\(\d{4}-\d{2}-\d{2}\))/)?.[1] ?? '';
  return `${version} ${date}`.trim();
}

function mergeVersionContent(version: ChangelogProps) {
  version.versionContent = version.actions
    .map(
      action =>
        `${action.name ? `### ${action.name}\n` : ''}\n${action.content}`,
    )
    .join('\n')
    .trim();
  return version;
}
